import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import ErrorBoundary from 'Hoc/ErrorBoundary'
import { ListenerProvider } from 'Hoc/ListenerProvider'
import { LocationProvider } from 'Hoc/LocationContext'
import { Provider } from 'react-redux'
import { HistoryRouter as Router } from 'redux-first-history/rr6'
import materialTheme from 'Style/themes/theme'
import { getBankFromPath } from 'Utility/bankMethods'
import { cleanPathFromTheme, redirectToLogin } from 'Utility/globalMethods'
import LanguageProvider from 'Hoc/LanguageProvider'
import { routesList } from 'Schemas/routesList'
import NpgFeMerchantPortal from './NpgFeMerchantPortalContainer'
import 'Style/scss/main.scss'

const theme = createTheme(materialTheme)

const MainContainer = ({ authRoutes, unauthRoutes, store, logged, history, ...rest }) => {
  const themeFromPath = getBankFromPath() // Case 302 GET /{theme}/authorize#code=...&state=... save theme from path
  const currentPath = window.location.pathname
  const isLoginRoute = currentPath.includes(routesList.goToLogin)
  const isAuthorizeRoute = !unauthRoutes.routes.some(
    (el) => `/${el.key.toLowerCase()}` === cleanPathFromTheme(currentPath)
  )

  useEffect(() => {
    // Redirect unauthenticated users to login if you're on the root "/" without a theme OR
    // Redirect unauthenticated users to login except when already on login or authorize routes.
    
    const shouldRedirectToLogin = !logged && (currentPath === '/' || (!isLoginRoute && isAuthorizeRoute))

    if (shouldRedirectToLogin) {
      redirectToLogin()
    }
    
    if (
      logged && isAuthorizeRoute
    ) {
      store.dispatch({ type: '@@user/get_user_profile', payload: {} })
      store.dispatch({ type: '@@ttl/ttl_control', payload: {} })
    }
  }, [logged])

  return (
    <Provider store={store}>
      {/* <AnalyticsProvider> */}
      <Router 
        history={history} 
        basename={isLoginRoute ? '/' : (themeFromPath ? `/${themeFromPath}` : '/')}
      >
        <LocationProvider>
          <ThemeProvider theme={theme}>
            <LanguageProvider>
              <ErrorBoundary>
                <ListenerProvider>
                  <NpgFeMerchantPortal logged={logged} authRoutes={authRoutes} unauthRoutes={unauthRoutes} {...rest} />
                </ListenerProvider>
              </ErrorBoundary>
            </LanguageProvider>
          </ThemeProvider>
        </LocationProvider>
      </Router>
      {/* </AnalyticsProvider> */}
    </Provider>
  )
}

MainContainer.propTypes = {
  authRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  unauthRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  logged: PropTypes.bool.isRequired
}

export default MainContainer
